import React, { FC, ReactElement } from 'react';

import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';

import InitialConfigFormFields from '../../models/InitialConfigFormFields';
import ConnectForm from '../../../../common/reactHookForm/ConnectForm';
import { HelperTextInputField } from '@thingslog/ui-components';

const ModbusGenericDigitalConfig: FC<ModbusGenericDigitalConfigProps> = ({
  index,
}: ModbusGenericDigitalConfigProps) => {
  const { t } = useTranslation();
  return (
    <ConnectForm<InitialConfigFormFields>>
      {({ register }: UseFormReturn<InitialConfigFormFields>): ReactElement => (
        <>
          <HelperTextInputField
            {...register(`ports.${index}.sensor.count`)}
            label={t('sensor_config_count')}
            size="small"
          />
        </>
      )}
    </ConnectForm>
  );
};

interface ModbusGenericDigitalConfigProps {
  index: number;
}

export default ModbusGenericDigitalConfig;
